import { Immutable } from "immer";
import React from "react";

import { IOptionCode, IOptionSingleValue } from "../../models/catalogue";
import { SelectOptions } from "../SelectOptions";

type IProps = Immutable<{
    code: IOptionCode;
    value?: IOptionSingleValue;
    options: IOptionSingleValue[];
    prefixNameCapped: string;
    configuratorClass: string;
    prefixClass: string;
    selectClass: string;
    onChange: (event: React.FormEvent<HTMLSelectElement>) => void;
}>;

export const ProductOptionClassicSelector = ({
    code,
    value,
    options,
    prefixNameCapped,
    configuratorClass,
    prefixClass,
    selectClass,
    onChange,
}: IProps): React.ReactNode => {
    const currentValue = value ?? "";
    if (options.length === 1) {
        return (
            <div key={code} className={configuratorClass}>
                <span>
                    {prefixNameCapped}: {currentValue}
                </span>
            </div>
        );
    }
    return (
        <div key={code} className={configuratorClass}>
            <label htmlFor={code} className={prefixClass}>
                {prefixNameCapped}
            </label>
            <select
                value={currentValue}
                name={code}
                onChange={onChange}
                className={selectClass}
            >
                <optgroup label={prefixNameCapped}>
                    <SelectOptions options={options} />
                </optgroup>
            </select>
        </div>
    );
};
